const optionsRequests = new Map();
const OPTIONS_CACHE_TIME = 60000;

export default {
  getTheme(id) {
    return axios.get(`/themes/${id}`, {
      params: { view: 'editor' },
      timeout: 30000,
    });
  },
  getMultiple(ids) {
    return axios.get('/themes', {
      params: { ids, view: 'editor' },
      timeout: 30000,
    });
  },
  getTemplateOptions(instanceId, layoutId) {
    const key = `${layoutId}:${instanceId}`;
    const cached = optionsRequests.get(key);

    if (cached && cached.expiresAt > Date.now()) {
      return cached.promise;
    }

    const promise = axios.get('/banner/get-template-themes', {
      params: { instance_id: instanceId, layout_id: layoutId },
      timeout: 30000,
    }).catch(error => {
      optionsRequests.delete(key);
      throw error;
    });

    optionsRequests.set(key, {
      promise,
      expiresAt: Date.now() + OPTIONS_CACHE_TIME,
    });

    return promise;
  },
};
